import { generateDataModule } from 'admin/modules/generateModule'
import { serviceGetNetworkDailyScores } from 'admin/services/bluetrace'

import { eventTimezoneSelector } from 'admin/modules/events'


const EmployeeContagionDailyScoresModule = generateDataModule({
  initialData: {
    previousWeek: [],
    currentWeek: [],
  },
  moduleKey: 'cpo/bluetrace/employeeDailyScores',
  reducerKey: 'admin.bluetrace.employeeContagion.dailyScores',
  refreshTime: 10000,
  services: {
    get: { service: serviceGetNetworkDailyScores },
  },
})


// //////////////////////////////////////////////////////////////////////////////////////
// Selectors
// //////////////////////////////////////////////////////////////////////////////////////
EmployeeContagionDailyScoresModule.registerSelector(
  'dailyScores',
  (state, moduleState) => moduleState.data,
  value => value
)

// //////////////////////////////////////////////////////////////////////////////////////
// Actions
// //////////////////////////////////////////////////////////////////////////////////////

EmployeeContagionDailyScoresModule.registerDataAction('get', (employeeId) => (dispatch, getState) => {
  const state = getState()
  if (!employeeId) return Promise.resolve()

  const timezone = eventTimezoneSelector(state)

  dispatch({ type: EmployeeContagionDailyScoresModule.actionKeys.getStart })

  return EmployeeContagionDailyScoresModule._getService('get')(employeeId, timezone)
    .then(response => dispatch({ type: EmployeeContagionDailyScoresModule.actionKeys.getSuccess, payload: response }))
    .catch(() => {
      dispatch({ type: EmployeeContagionDailyScoresModule.actionKeys.getError })
      return Promise.reject()
    })
})


// //////////////////////////////////////////////////////////////////////////////////////
// Reducers
// //////////////////////////////////////////////////////////////////////////////////////


export default EmployeeContagionDailyScoresModule
